import { createContext } from "react";

const fetchContext = createContext([{}, function () {}]);

export default fetchContext;
